import { ConfiguratorV2 } from "@screens/configurator-v2"
import { NextPage } from "next"

const ConfiguratorPage: NextPage<{}> = () => <ConfiguratorV2 />

export default ConfiguratorPage
